import styled from '@emotion/styled';
import { t } from '@lingui/macro';
import { useTableContext } from '../providers/TableProvider';

interface PaginationProps {
  onPageChange?: () => void;
}

export const Pagination = ({ onPageChange }: PaginationProps) => {
  const { table } = useTableContext();

  if (!table.getCanNextPage() && !table.getCanPreviousPage()) {
    return null;
  }

  return (
    <Container>
      <button
        onClick={() => {
          onPageChange?.();
          table.setPageIndex(0);
        }}
        disabled={!table.getCanPreviousPage()}
        title={t`Go to page 1`}
      >
        {'<<'}
      </button>
      <button
        onClick={() => {
          onPageChange?.();
          table.previousPage();
        }}
        disabled={!table.getCanPreviousPage()}
        title={t`Go to previous page`}
      >
        {'<'}
      </button>
      <button
        onClick={() => {
          onPageChange?.();
          table.nextPage();
        }}
        disabled={!table.getCanNextPage()}
        title={t`Go to next page`}
      >
        {'>'}
      </button>
      {/*<button
        onClick={() => table.setPageIndex(table.getPageCount() - 1)}
        disabled={!table.getCanNextPage()}
      >
        {'>>'}
      </button>*/}
      <span data-testid="pagenumber">
        <div>Page</div>
        <strong>
          {table.getState().pagination.pageIndex + 1}
          {/* of {table.getPageCount()}*/}
        </strong>
      </span>
      {/*<span>
        Go to page:
        <input
          type="number"
          defaultValue={table.getState().pagination.pageIndex + 1}
          onChange={e => {
            const page = e.target.value ? Number(e.target.value) - 1 : 0;
            table.setPageIndex(page);
          }}
        />
      </span>*/}
      {/*<select
        value={table.getState().pagination.pageSize}
        onChange={e => {
          table.setPageSize(Number(e.target.value));
        }}
      >
        {[10, 20, 30, 40, 50].map(pageSize => (
          <option key={pageSize} value={pageSize}>
            Show {pageSize}
          </option>
        ))}
      </select>*/}
    </Container>
  );
};

export const Container = styled.div`
  position: sticky;
  left: 0;
  display: flex;
  flex-shrink: 0;
  height: 50px;
  button,
  select {
    padding: 0.5rem 1rem;
    background: none;
    border: 0;
  }

  input {
    max-width: 80px;
  }

  span {
    align-self: center;
    padding: 0.5rem 1rem;
    flex-shrink: 0;
    display: flex;
    gap: 0.25rem;
  }
`;
